var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var _a;
import styled from 'styled-components';
import * as utils from '../../utils';
import { Size } from './button';
var modifiers = (_a = {},
    _a[Size.small] = { size: 36 },
    _a[Size.medium] = { size: 44 },
    _a[Size.large] = { size: 52 },
    _a[Size.wide] = { size: 64 },
    _a);
var IconButton = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", "px;\n  height: ", "px;\n  background-color: ", ";\n  color: ", ";\n  cursor: ", ";\n  border-radius: 50%;\n  border: none;\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  &:focus,\n  &:focus-visible {\n    background-color: ", ";\n    position: relative;\n    outline: none;\n  }\n\n  &:focus-visible:after {\n    position: absolute;\n    width: calc(100% + 4px);\n    height: calc(100% + 4px);\n    transform: translate(-50%, -50%);\n    border: 2px solid ", ";\n    border-radius: 3px;\n    top: 50%;\n    left: 50%;\n    content: '';\n  }\n\n  &:active {\n    background-color: ", ";\n    -moz-box-shadow: inset 0px 4px 4px ", ";\n    -webkit-box-shadow: inset 0px 4px 4px ", ";\n    box-shadow: inset 0px 4px 4px ", ";\n  }\n"], ["\n  width: ", "px;\n  height: ", "px;\n  background-color: ", ";\n  color: ", ";\n  cursor: ", ";\n  border-radius: 50%;\n  border: none;\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  &:focus,\n  &:focus-visible {\n    background-color: ", ";\n    position: relative;\n    outline: none;\n  }\n\n  &:focus-visible:after {\n    position: absolute;\n    width: calc(100% + 4px);\n    height: calc(100% + 4px);\n    transform: translate(-50%, -50%);\n    border: 2px solid ", ";\n    border-radius: 3px;\n    top: 50%;\n    left: 50%;\n    content: '';\n  }\n\n  &:active {\n    background-color: ", ";\n    -moz-box-shadow: inset 0px 4px 4px ", ";\n    -webkit-box-shadow: inset 0px 4px 4px ", ";\n    box-shadow: inset 0px 4px 4px ", ";\n  }\n"])), function (_a) {
    var size = _a.size;
    return size && modifiers[size].size;
}, function (_a) {
    var size = _a.size;
    return size && modifiers[size].size;
}, function (_a) {
    var disabled = _a.disabled, theme = _a.theme;
    return disabled ? utils.hexToRGBA(theme.colors.neutral7, theme.alpha.dark) : theme.colors.primary;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral1;
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'default' : 'pointer');
}, function (_a) {
    var disabled = _a.disabled, theme = _a.theme;
    return !disabled && theme.colors.primaryDark;
}, function (_a) {
    var disabled = _a.disabled, theme = _a.theme;
    return !disabled && theme.colors.primaryDark;
}, function (_a) {
    var disabled = _a.disabled, theme = _a.theme;
    return !disabled && theme.colors.neutral7;
}, function (_a) {
    var disabled = _a.disabled, theme = _a.theme;
    return !disabled && theme.colors.primary;
}, function (_a) {
    var theme = _a.theme;
    return utils.hexToRGBA(theme.colors.neutral7, theme.alpha.medium);
}, function (_a) {
    var theme = _a.theme;
    return utils.hexToRGBA(theme.colors.neutral7, theme.alpha.medium);
}, function (_a) {
    var theme = _a.theme;
    return utils.hexToRGBA(theme.colors.neutral7, theme.alpha.medium);
});
IconButton.defaultProps = {
    disabled: false,
    size: Size.medium,
};
export default IconButton;
var templateObject_1;
//# sourceMappingURL=icon.js.map